import React, { FC, ReactNode } from 'react';

import DropdownMenu, { RenderProp } from '../DropdownMenu/DropdownMenu';
import { Trigger, TriggerButtonProps } from '../DropdownMenu/TriggerButton';

interface MenuProps {
  children: ReactNode | RenderProp;
  trigger: Trigger<TriggerButtonProps>;
  title: string;
}

const Menu: FC<MenuProps> = ({ children, title, trigger }) => (
  <DropdownMenu className="Menu" title={title} trigger={trigger}>
    {children}
  </DropdownMenu>
);

export default Menu;
